import React from 'react';
import Script from 'next/script';

import { IOutgrowFields } from '@/types/contentful';

export default function FloatingRectangle({ code }: Partial<IOutgrowFields>) {
  return code ? (
    <>
      <div
        dangerouslySetInnerHTML={{ __html: code || '' }}
        data-testid="outgrow-rectangle"
      />
      <Script
        id="outgrow-floating-rectangle"
        strategy="afterInteractive"
        src="https://dyv6f9ner1ir9.cloudfront.net/assets/js/float.js"
      />
    </>
  ) : null;
}
